import axios from 'axios';
import { GSDDAuditOverride } from '@/models/Drug/GSDDAuditOverride';

export class GSDDAuditOverrideService {
    /**
     * Get audit override by Package ID
     * @param packageId - The GSDD Package ID
     * @returns Promise with the audit override or null if not found
     */
    static async getByPackageId(packageId: number): Promise<GSDDAuditOverride | null> {
        try {
            const response = await axios.get<GSDDAuditOverride>(`/api/GSDDAuditOverride/${packageId}`);
            return response.data;
        } catch (error: any) {
            if (error.response?.status === 404) {
                return null;
            }
            console.error('Error getting GSDD audit override:', error);
            throw error;
        }
    }

    /**
     * Save or update audit override
     * @param override - The audit override to save
     * @returns Promise with the saved audit override
     */
    static async save(override: GSDDAuditOverride): Promise<GSDDAuditOverride> {
        try {
            const response = await axios.post<GSDDAuditOverride>('/api/GSDDAuditOverride', override);
            return response.data;
        } catch (error) {
            console.error('Error saving GSDD audit override:', error);
            throw error;
        }
    }
}
